define('Cubix_LooseDiamond/js/diamondcompare_product',[
    "jquery",
    "owlcarousel"
], function ($) {
    'use strict';
    $.widget(
        'cubix.diamondcompare_product', {
        options: {
            compareapi: '',
            $compareCarousel: false,
            ring_builder: 0
        },
        _create: function () {
            this._EventListener();
        },
        _EventListener: function () {
            var $widget = this;

            $(document).on('click','.compareviewtype',function(e) {
                e.preventDefault();
                var viewtype = $(this).data('view');
                $('.compareviewtype').removeClass('active');
                $(this).addClass('active');
                $('.compare-view').addClass('d-none');
                $('.compare-view-'+viewtype).removeClass('d-none');
            });

            $(document).on('change','.addcomparision',function(e){
                $widget.addToCompare($(this),false);
            });

            $(document).on('change','.alias-addcomparision',function(e){
                var dynamic_compare_id = '.'+$(this).data('compareid');
                $(dynamic_compare_id).click();
                if($(this).is(':checked')) {
                    $(dynamic_compare_id).prop('checked', true); 
                }
                else {
                    $(dynamic_compare_id).prop('checked', false);
                }
            });

            $(document).on('click','.closecomparision',function(e) {
                $widget.addToCompare($(this),true);
            });

            $(document).on('click','.closecomparision-block',function(e) {
                $('#show_hide_comparision').removeClass("active");
                $('.diamond_comparision').hide();
                $('.diamondpart').show();
            });

            $(document).on('click','#show_hide_comparision',function(e) {
                if ($(this).hasClass("active") ) {
                    $(this).removeClass("active");
                    $('.diamond_comparision').hide();
                    $('.diamondpart').show();
                }
                else {
                    $(this).addClass("active");
                    $('.diamond_comparision').show();
                    $('.diamondpart').hide();
                }
            });

            $('.mobile-filters-normal .trigger, .mobile-filters-advance .trigger').click(function() {
                $('.slider-panel').addClass('close_mobile');
                var id = $(this).data('panel-id');
                $('#'+id).removeClass('close_mobile');
                $('.mobile-filter-overlay').show();
            });

            $('.slider-panel .card-body').click(function(e) {
                e.stopPropagation();
            });

            $('.slider-panel').click(function() {
                $(this).addClass('close_mobile');
                $('.mobile-filter-overlay').hide();
            });

            $widget.options.$compareCarousel = $('.scroll-column');
            $widget.options.$compareCarousel.owlCarousel({
                loop:false,
                nav:true,
                dots:true,
                responsive:{
                  0:{
                      items:2,
                      dots:true,
                      nav:true
                  },
                  768:{
                      items:2,
                      dots:true,
                      nav:true
                  },
                  1024:{
                      items: 3,
                      dots:true,
                      nav:true
                  }
                }
            });
            $('.diamond_comparision .btn-next').click(function() {
                $widget.options.$compareCarousel.trigger('next.owl.carousel');
            });

            $('.diamond_comparision .btn-prev').click(function() {
                $widget.options.$compareCarousel.trigger('prev.owl.carousel');
            });
        },
        addToCompare: function (element,uncheck) {
            var $widget = this;
            var stock_id = $(element).attr("data-diamondid");
            var diamond_id = $(element).attr("data-id");
            var diamond_type = $(element).attr("data-type");
            if(uncheck==true) {
                if($('#'+diamond_type+diamond_id).length > 0) {
                    $('#'+diamond_type+diamond_id).prop("checked", false);
                }
            }

            var diamond_status = 0;

            if (element.is(':checked')) {
                diamond_status = 1;
            } else {
                var diamond_div = '.' + diamond_type + '.diamond_' + diamond_id;
                diamond_status = 0;
                if( $('#mobile-compare').length ) {
                    $(diamond_div).remove();
                }
                else {
                    var item_index = $(diamond_div).parent().index();
                    $widget.options.$compareCarousel.trigger('remove.owl.carousel', [item_index]);
                }
            }

            var data = {
                stock_id : stock_id,
                diamond_id : diamond_id,
                diamond_type : diamond_type,
                diamond_status : diamond_status,
                ring_builder : $widget.options.ring_builder
            };

            var compare_count = parseInt($('#total_comparision').val());
            if(diamond_status==1) {
                compare_count = compare_count + 1;
            }
            else {
                compare_count = compare_count - 1;
                compare_count = Math.max(0,compare_count);
            }
            $('#total_comparision').val(compare_count);
            $('#compare_count').text(compare_count);
            $('#dh_loading').show();
            var $widget = this;
            var compareapi = $widget.options.compareapi;
            $.ajax({
                type: "POST",
                url: compareapi,
                data: data,
                dataType: 'json',
                success: function(data) {
                    $('#dh_loading').hide();
                    if( $('#mobile-compare').length ) {
                        if(data.output!='') {
                            $('.compare-view-grid').prepend(data.output);
                        }
                        if(data.output_list!='') {
                            $('.compare-view-list .compare-data-row').prepend(data.output_list);
                        }
                    }
                    else {
                        if(data.output!='') {
                            $widget.options.$compareCarousel.trigger('add.owl.carousel',[data.output]);
                        }
                        $widget.options.$compareCarousel.trigger('refresh.owl.carousel');
                    }
                    var metal = $(".metal_type_option:checked").data("metal");
                    if($('.'+ metal + '_squere.gallery_switcher').length) {
                        var gallery = $('.'+ metal + '_squere.gallery_switcher').data('gallery')[1];
                        $('.diamond-product-img').attr('src',gallery.img);
                    }
                },
                failure: function(errMsg) {
                    $('#dh_loading').hide();
                    console.log(errMsg);
                }
            });
        }
    });
    return $.cubix.diamondcompare_product;
});

